// Identified writes to Ortto from the widget: "this visitor is <email>".
//
// Two rules, both decided on the consent thread (frontend repo,
// docs/side/consent/discussion.md), replace the three bare `ap3c.track({v:0, email})` calls
// this module absorbed on 6 Oct 2026:
//
//  1. Tracking follows consent (28 Sep). The write is sent only when the visitor has granted the
//     consent type below in CookieScript. No cookie means the banner has not been answered yet —
//     both www.24rent.fi and rent.24rent.fi load CookieScript — so nothing is sent.
//
//  2. Never subscribe (6 Oct). Ortto's tracking-code documentation: "Contacts created via user
//     session association are subscribed in Ortto by default. If you want the opposite behavior
//     (to create them as unsubscribed by default), include unsubscribe: true in the ap3c.track
//     call." A login is not a marketing opt-in, so the flag is always sent. Per that wording it
//     governs how a new contact is created; it is not documented to change an existing contact.
//
// Which consent type gates the write was decided twice: analytics on 28 Sep, and confirmed as
// analytics by Matti on 6 Oct 2026 after the subscription-by-default behaviour was known
// ("Ortto is analytics"). The constant below is that decision.
//
// The function never throws. Every caller sits on a success path (login, customer saved), and
// an Ortto problem must not divert that path into its error handling.

import { readCookieScriptConsent, type GoogleConsentType } from './cookieScriptConsent';

export const ORTTO_IDENTIFY_CONSENT: GoogleConsentType = 'analytics_storage';

export function identifyOrttoContact(email: string | null | undefined): boolean {
    try {
        if (typeof email !== 'string') return false;
        const trimmed = email.trim();
        if (trimmed === '') return false;
        if (typeof window === 'undefined' || typeof document === 'undefined') return false;

        const ap3c = window.ap3c;
        if (!ap3c || typeof ap3c.track !== 'function') return false;

        if (readCookieScriptConsent(document.cookie, ORTTO_IDENTIFY_CONSENT) !== 'granted') return false;

        ap3c.track({ v: 0, email: trimmed, unsubscribe: true });
        return true;
    } catch {
        return false;
    }
}
